{
  "vitalsEntry": {
    "title": "バイタルサイン",
    "subtitle": "バイタルサインを記録および確認します",
    "printLabel": "バイタルを印刷",
    "recordSection": "バイタルを記録",
    "save": "バイタルを記録",
    "cancel": "キャンセル",
    "saving": "記録中...",
    "recordedSuccess": "バイタルを記録しました",
    "recordedError": "バイタルの記録に失敗しました",
    "invalidEncounter": "受診IDが無効です。",
    "historyTitle": "直近のバイタル",
    "loadingHistory": "バイタルを読み込んでいます...",
    "loadError": "バイタルの読み込みに失敗しました。",
    "emptyHistory": "この受診ではバイタルが記録されていません。",
    "morseTitle": "Morse 転倒リスク評価尺度",
    "bradenTitle": "Braden 褥瘡リスク評価尺度",
    "riskScalesSaved": "リスクスコアを記録しました",
    "riskScalesFailed": "バイタルは保存されましたが、リスクスコアの記録に失敗しました"
  },
  "vitals": {
    "systolic": "収縮期血圧",
    "diastolic": "拡張期血圧",
    "heartRate": "心拍数",
    "respiratoryRate": "呼吸数",
    "temperature": "体温",
    "oxygenSaturation": "酸素飽和度 (SpO2)",
    "oxygenSaturationShort": "SpO2",
    "painScore": "疼痛スコア",
    "weight": "体重",
    "height": "身長",
    "bmi": "BMI",
    "rangeError": "{{field}}は {{min}} から {{max}} の範囲で入力してください",
    "placeholders": {
      "temperature": "例: 37.0",
      "heartRate": "例: 72",
      "respiratoryRate": "例: 16",
      "oxygenSaturation": "例: 98",
      "systolic": "例: 120",
      "diastolic": "例: 80",
      "weight": "例: 70.5",
      "height": "例: 175",
      "painScore": "0-10"
    }
  },
  "vitalsRange": {
    "normal": "正常",
    "borderline": "境界域",
    "abnormal": "異常",
    "critical": "危機的"
  },
  "tableHeaders": {
    "dateTime": "日時",
    "temperature": "体温",
    "heartRate": "心拍",
    "respiratoryRate": "呼吸",
    "bloodPressure": "血圧",
    "oxygenSaturation": "SpO2",
    "weight": "体重",
    "height": "身長",
    "pain": "疼痛"
  },
  "io": {
    "title": "イン・アウト",
    "addRecord": "記録を追加",
    "addRecordSection": "イン・アウト記録を追加",
    "loading": "イン・アウト記録を読み込んでいます...",
    "loadError": "イン・アウト記録の読み込みに失敗しました。",
    "empty": "この受診ではイン・アウト記録がありません。",
    "totals": {
      "intake": "総摂取量",
      "output": "総排泄量",
      "balance": "差引バランス",
      "totalsRow": "合計",
      "netLabel": "差引"
    },
    "negativeWarning": "マイナスバランス — 体液状態を確認してください",
    "columns": {
      "dateTime": "日時",
      "type": "区分",
      "category": "カテゴリ",
      "amount": "量 (ml)",
      "notes": "備考"
    },
    "fields": {
      "type": "区分",
      "category": "カテゴリ",
      "amount": "量 (ml)",
      "notes": "備考"
    },
    "type": {
      "intake": "摂取",
      "output": "排泄"
    },
    "categoryPlaceholder": "カテゴリを選択...",
    "amountPlaceholder": "0",
    "notesPlaceholder": "任意の備考...",
    "save": "記録を保存",
    "cancel": "キャンセル",
    "missingValueShort": "--",
    "toast": {
      "added": "イン・アウト記録を追加しました",
      "addFailed": "イン・アウト記録の追加に失敗しました",
      "missingFields": "必須項目を入力してください"
    }
  },
  "intake": {
    "oral": "経口",
    "iv": "IV",
    "bloodProducts": "血液製剤",
    "tpn": "TPN",
    "tubeFeeding": "経管栄養",
    "other": "その他"
  },
  "output": {
    "urine": "尿",
    "drain": "ドレーン",
    "emesis": "嘔吐物",
    "stool": "便",
    "bloodLoss": "出血",
    "ngSuction": "NG 吸引",
    "other": "その他"
  },
  "wound": {
    "title": "創傷ケア記録",
    "subtitle": "受診 #{{id}} — 構造化された創傷評価",
    "newAssessment": "新規創傷評価",
    "dimensionsTitle": "サイズ (cm)",
    "woundBedTitle": "創底 (%)",
    "woundBedTotalWarning": "合計：{{total}}%（100% にする必要があります）",
    "woundBedTotalOk": "合計：100%",
    "previousTitle": "過去の評価",
    "empty": "この受診では創傷評価が記録されていません。",
    "invalidEncounter": "受診IDが無効です。",
    "save": "評価を保存",
    "savedSuccess": "創傷評価を記録しました",
    "savedError": "創傷評価の保存に失敗しました",
    "fields": {
      "woundType": "創傷の種類",
      "location": "部位",
      "stage": "ステージ",
      "length": "長さ",
      "width": "幅",
      "depth": "深さ",
      "granulation": "肉芽組織",
      "slough": "スラフ",
      "eschar": "壊死組織（エスカー）",
      "epithelial": "上皮",
      "drainageType": "滲出液の種類",
      "drainageAmount": "滲出液の量",
      "surroundingSkin": "周囲皮膚",
      "treatment": "実施した処置",
      "painScore": "疼痛スコア (0-10)",
      "notes": "備考"
    },
    "placeholders": {
      "length": "例: 3.5",
      "width": "例: 2.0",
      "depth": "例: 0.5",
      "treatment": "実施した創傷ケアを記述...",
      "notes": "追加の所見..."
    },
    "history": {
      "dimensionsLabel": "サイズ",
      "drainageLabel": "滲出液",
      "painLabel": "疼痛",
      "treatmentLabel": "処置"
    },
    "stage": {
      "stage1": "ステージ 1",
      "stage2": "ステージ 2",
      "stage3": "ステージ 3",
      "stage4": "ステージ 4",
      "unstageable": "判定不能",
      "deepTissue": "深部組織損傷",
      "na": "N/A"
    },
    "drainageType": {
      "none": "なし",
      "serous": "漿液性",
      "sanguineous": "血性",
      "serosanguineous": "漿液血性",
      "purulent": "膿性"
    },
    "drainageAmount": {
      "none": "なし",
      "scant": "極少量",
      "small": "少量",
      "moderate": "中等量",
      "large": "大量",
      "copious": "多量"
    },
    "woundType": {
      "pressure": "褥瘡（圧迫損傷）",
      "surgical": "手術創",
      "diabetic": "糖尿病性潰瘍",
      "venous": "静脈性潰瘍",
      "arterial": "動脈性潰瘍",
      "traumatic": "外傷性",
      "skinTear": "スキンテア",
      "other": "その他"
    },
    "location": {
      "sacrum": "仙骨部",
      "coccyx": "尾骨部",
      "leftHeel": "左踵",
      "rightHeel": "右踵",
      "leftTrochanter": "左大転子",
      "rightTrochanter": "右大転子",
      "abdomen": "腹部",
      "leftLeg": "左下腿",
      "rightLeg": "右下腿",
      "back": "背部",
      "other": "その他"
    },
    "surroundingSkin": {
      "intact": "正常",
      "erythema": "紅斑",
      "macerated": "浸軟",
      "indurated": "硬結",
      "edematous": "浮腫",
      "warm": "熱感",
      "discolored": "変色"
    }
  },
  "carePlan": {
    "title": "ケアプラン",
    "addPlan": "ケアプランを追加",
    "newPlan": "新規ケアプラン",
    "createPlan": "プランを作成",
    "cancel": "キャンセル",
    "empty": "この患者にはケアプランが記録されていません。",
    "emptyGoals": "目標が設定されていません。",
    "goals": "目標",
    "addGoal": "目標を追加",
    "saving": "保存中...",
    "loading": "ケアプランを読み込んでいます...",
    "loadError": "ケアプランの読み込みに失敗しました。",
    "fields": {
      "title": "タイトル",
      "startDate": "開始日",
      "targetDate": "目標日",
      "description": "内容",
      "target": "目標値"
    },
    "placeholders": {
      "title": "例: 転倒予防プラン",
      "description": "目標の内容",
      "target": "例: 30日以内に転倒なし"
    },
    "history": {
      "startLabel": "開始",
      "targetLabel": "目標",
      "goalsLabel": "目標数"
    },
    "status": {
      "active": "進行中",
      "completed": "完了",
      "cancelled": "中止"
    },
    "goalStatus": {
      "inProgress": "進行中",
      "achieved": "達成",
      "notAchieved": "未達成"
    },
    "toast": {
      "planCreated": "ケアプランを作成しました",
      "planCreateFailed": "ケアプランの作成に失敗しました",
      "goalAdded": "目標を追加しました",
      "goalAddFailed": "目標の追加に失敗しました",
      "planValidation": "タイトルと開始日は必須です",
      "goalValidation": "内容と目標値は必須です"
    }
  }
}
